export default "__VITE_ASSET__raSPLH2z__"